/**
 * Application Configuration
 * All configuration injected at build time (no .env dependency)
 */

// Build-time client config (injected by build script via vite)
declare const __APP_CONFIG__: any;

// Build config is required - no fallbacks
if (typeof __APP_CONFIG__ === 'undefined') {
  throw new Error('❌ Application configuration not found. Build script must inject __APP_CONFIG__.');
}

const config = __APP_CONFIG__;

// API Configuration
export const API_CONFIG = {
  url: config.apiUrl,
} as const;

// Authentication Configuration  
export const AUTH_CONFIG = {
  tokenKey: config.authTokenKey,
} as const;

// Client Configuration
export const CLIENT_CONFIG = {
  domain: config.domain,
  name: config.name,
  clientId: config.client_id,
} as const;

// Assets Configuration
export const ASSETS_CONFIG = {
  // Logo is downloaded during build and placed in public/assets/logo.png
  // Use this path in your components: <img src={ASSETS_CONFIG.logo} alt="Logo" />
  logo: '/assets/logo.png',
} as const;

// Environment Configuration
export const ENV_CONFIG = {
  isDevelopment: config.appEnv === 'development',
  isProduction: config.appEnv === 'production',
} as const;

// Export main config
export const CONFIG = {
  API: API_CONFIG,
  AUTH: AUTH_CONFIG,
  CLIENT: CLIENT_CONFIG,
  ENV: ENV_CONFIG,
  ASSETS: ASSETS_CONFIG,
} as const;
